/**
 * C 端官網（給客人用的快速收款等公開頁「回到首頁」）。
 * 本地可設 REACT_APP_CLIENT_PUBLIC_SITE_URL=http://localhost:3000
 */
export const CLIENT_PUBLIC_SITE_URL =
  process.env.REACT_APP_CLIENT_PUBLIC_SITE_URL || 'https://www.beautefeel.com'
